<script>
// Handle (aba na borda direita) que recolhe/expande o dock de atalhos
// flutuantes. Componente controlado — o estado vive no pai (main layout) e e
// persistido em localStorage; aqui so emitimos o toggle e refletimos o estado.
export default {
  name: 'FloatingDockToggle',
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onToggle() {
      this.$emit('toggle')
    },
  },
}
</script>

<template>
  <button
    type="button"
    class="floating-dock-toggle"
    :class="{ 'floating-dock-toggle--collapsed': collapsed }"
    :aria-pressed="collapsed ? 'true' : 'false'"
    :aria-label="
      collapsed ? 'Expandir atalhos flutuantes' : 'Recolher atalhos flutuantes'
    "
    :title="collapsed ? 'Expandir atalhos' : 'Recolher atalhos'"
    @click="onToggle"
  >
    <v-fab-transition mode="out-in">
      <icon-svg
        :key="collapsed ? 'expand' : 'collapse'"
        :name="collapsed ? 'mdi-chevron-left' : 'mdi-chevron-right'"
        :size="22"
        color="#FFFFFF"
      />
    </v-fab-transition>
  </button>
</template>

<style scoped lang="sass">
.floating-dock-toggle
  position: fixed
  right: 0
  bottom: 28px
  z-index: 201
  display: flex
  align-items: center
  justify-content: center
  width: 26px
  height: 52px
  padding: 0
  border: none
  cursor: pointer
  // Cor primária do escritório (white-label) — nunca hardcode.
  background: var(--primary)
  color: white
  border-radius: 8px 0 0 8px
  box-shadow: -2px 2px 10px rgba(0, 0, 0, 0.2)
  transition: filter 0.15s ease
  &:hover
    // primary "mais leve" no hover — clareia sem trocar a cor base
    filter: brightness(1.1)

@media print
  .floating-dock-toggle
    display: none !important
</style>
